export default "__VITE_ASSET__FzpHIFZK__"